<template>
  <div id="sales-page" class="container">
    <div class="section">
      <h1 class="title-underline">Today's Best Deals</h1>
      <div>
      </div>
      <hr>
      <div class="text-center">
        <h4 class="title-two-tone"><i class="fa fa-fire" aria-hidden="true"></i>&nbsp;Stock Up And&nbsp;<span>Save</span>
        </h4>
        <h5>{{ promoMessage }}</h5>
      </div>
      <div v-if="$root.hasSalesPromo">
        <SalesContent />
        <CustomProductList :limit="30" :allcats="queryBuilder" @add-swatch-to-cart="addSwatchToCart" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomProductList from '../../page_components/CustomProductList.vue';
import SalesContent from '../../page_components/SalesContent.vue';

export default {
  name: 'sales',

  components: {
    CustomProductList,
    SalesContent
  },

  computed: {
    getFinishParam() {
      return this.checkPromo('finishes');
    },

    getColorParam() {
      return this.checkPromo('color');
    },

    queryBuilder() {
      let hasFinishOParam = this.getFinishParam !== null && this.getFinishParam !== undefined;
      let hasColorParam = this.getColorParam !== null && this.getColorParam !== undefined;

      if (hasFinishOParam && hasColorParam) {
        return `${this.getFinishParam},color=${this.getColorParam}`;
      }

      if (hasFinishOParam) {
        return this.getFinishParam;
      }

      if (hasColorParam) {
        return this.getColorParam;
      }

      return 'pris_sales';
    },

    promoMessage() {
      if (this.$root.hasSalesPromo) {
        return this.$root.notifications[0]?.message;
      }

      return 'There are no active promos. Check back soon!';
    }
  },

  methods: {
    checkPromo(type) {
      const paramType = type;
      const promoUrl = this.$root.notifications[0]?.target_url;

      if (promoUrl === '') {
        return null;
      }

      if (promoUrl) {
        const isFinishPromo = new URL((promoUrl)).searchParams.has(type);

        if (isFinishPromo) {
          return new URL((promoUrl)).searchParams.get(paramType);
        }
      }
    },
    addSwatchToCart(swatch) {
      this.$emit("add-swatch-to-cart", swatch);
    },
  }
};
</script>

<style scoped lang="scss">
#sales-page {
  min-height: 100vh;
  max-height: 100vh;

  .section {
    hr {
      border-top: 2px solid #393939;
    }
  }
}
</style>
